/**
 * Resolves the API base URL.
 * 
 * - If VITE_API_URL is set (build-time or .env), use that directly.
 * - In production (custom domain), derive api.{domain}/api from the current hostname.
 * - In local dev, /api is proxied by Vite to the developer's deployed API.
 */
function resolveApiBase(): string {
  // Explicit override via env var
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL

  // Production: hostname is e.g. roneupan.bedrocklatency.tam.aws.dev
  // API is at api.roneupan.bedrocklatency.tam.aws.dev/api
  if (typeof window !== 'undefined' && window.location.hostname.includes('bedrocklatency.tam.aws.dev')) {
    return `https://api.${window.location.hostname}/api`
  }

  // Local dev: Vite proxies /api to the deployed API
  return '/api'
}

export const API_BASE = resolveApiBase()
